<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pa-8 fill-height"
  >
    <div
      class="d-flex justify-space-between align-center mt-4"
      height="220px"
    >
      <div
        class="d-flex justify-space-between"
        style="width: 50%"
      >
        <div class="d-flex justify-center align-center">
          <v-switch
            v-model="isAllPrint"
            :label="isAllPrint ? $t('print_all_enabled'):$t('print_all_is_not_enabled')"
            class="mt-1"
            hide-details
          />
        </div>

        <div class="mr-4">
          <v-text-field
            v-model="dates"
            :label="$t('selectDate')"
            append-icon="mdi-close"
            hide-details
            prepend-icon="mdi-calendar"
            style="max-width: 220px; "
            @change="reviewZbon"
            @click:append="clear"
          />
        </div>
      </div>

      <div
        class="d-flex align-center justify-space-between"
        style="width: 50%; "
      >
        <div
          class="pl-3"
          style="display: grid; grid-template-columns: repeat(3,1fr); grid-column-gap: 12px"
        >
          <v-btn
            class="mr-0"
            color="green lighten-2"
            large
            @click="sendZBonToEmail"
          >
            {{ $t('send_ZBon_to_email') }}
          </v-btn>

          <v-btn
            class="mr-0"
            color="primary"
            large
            @click="printZbonBySpan"
          >
            <v-icon left>
              mdi-printer
            </v-icon>
            {{ $t('print') }}
          </v-btn>
        </div>
      </div>
      <!--        </div>-->
    </div>
    <v-row>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <div style=" margin-top: 32px">
          <v-date-picker
            v-model="dates"
            :max="todayDate"
            full-width
            locale="de"
            range
            style="font-size: large; border-style: solid; border-color: #367aeb;"
          />
        </div>
      </v-col>

      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <div
          ref="pdf"
        >
          <v-card
            v-if="taxInfos.length>0"
            class="mt-8"
          >
            <v-card-title
              class="text-center justify-center text-h3 font-weight-bold"
            >
              <div>{{ $t('statistics') }}</div>
            </v-card-title>

            <div style="margin-left: 60px; margin-right: 60px; ">
              <v-divider/>
            </div>

            <div
              v-if="hide"
              class="py-6 px-6"
              style="margin-left: 40px; margin-right: 40px"
            >
              <div>{{ $t('selected_time_range') }}：{{ dates[0] }} ~ {{ dates[1] }}</div>
              <div>{{ $t('pdf_created_time') }}：{{ nowTime }}</div>
            </div>

            <!--              <div class="py-6 px-6 pb-2" >-->
            <div
              class="py-6 px-6 "
              style="margin-left: 40px; margin-right: 40px"
            >
              <div>
                <div class="d-flex justify-space-between text-subtitle-2 grey--text text--darken-2">
                  <div>{{ $t('umsatz_in_haus') }}{{ parseInt(taxInfos[1].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[1].taxGroupTotal|priceDisplay }}</div>
                </div>
                <div class="d-flex justify-space-between text-subtitle-2 grey--text text--darken-2">
                  <div>{{ $t('umsatz_ausser_haus') }}{{ parseInt(taxInfos[2].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[2].taxGroupTotal|priceDisplay }}</div>
                </div>
                <v-divider class="mx-2 my-2"/>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('GesamtUmsatz') }}{{ parseInt(taxInfos[0].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[1].taxGroupTotal + taxInfos[2].taxGroupTotal |priceDisplay }}</div>
                </div>
                <div class="d-flex justify-space-between grey--text text--darken-2">
                  <div>-{{ $t('MWST') }}</div>
                  <div>
                    {{
                      taxInfos[1].taxGroupTotal / (1 + taxInfos[1].taxRateGroupValue) * taxInfos[1].taxRateGroupValue +
                        taxInfos[2].taxGroupTotal / (1 + taxInfos[2].taxRateGroupValue) * taxInfos[2].taxRateGroupValue
                        |priceDisplay
                    }}
                  </div>
                </div>
                <div class="d-flex justify-space-between grey--text text--darken-2">
                  <div>-{{ $t('Netto') }}</div>
                  <div>
                    {{
                      taxInfos[1].taxGroupTotal / (1 + taxInfos[1].taxRateGroupValue) + taxInfos[2].taxGroupTotal / (1 +
                        taxInfos[2].taxRateGroupValue) |priceDisplay
                    }}
                  </div>
                </div>
                <v-divider class="mx-2 my-2"/>
                <div class="d-flex justify-space-between text-subtitle-2 grey--text text--darken-2">
                  <div>{{ $t('umsatz_in_haus') }}{{ parseInt(taxInfos[4].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[4].taxGroupTotal|priceDisplay }}</div>
                </div>
                <div class="d-flex justify-space-between text-subtitle-2 grey--text text--darken-2">
                  <div>{{ $t('umsatz_ausser_haus') }}{{ parseInt(taxInfos[5].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[5].taxGroupTotal|priceDisplay }}</div>
                </div>
                <v-divider class="mx-2 my-2"/>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('GesamtUmsatz') }}{{ parseInt(taxInfos[3].taxRateGroupValue * 100) }}%</div>
                  <div>{{ taxInfos[4].taxGroupTotal + taxInfos[5].taxGroupTotal |priceDisplay }}</div>
                </div>
                <div class="d-flex justify-space-between grey--text text--darken-2">
                  <div>-{{ $t('MWST') }}</div>
                  <div>
                    {{
                      taxInfos[4].taxGroupTotal / (1 + taxInfos[4].taxRateGroupValue) * taxInfos[4].taxRateGroupValue +
                        taxInfos[5].taxGroupTotal / (1 + taxInfos[5].taxRateGroupValue) * taxInfos[3].taxRateGroupValue
                        |priceDisplay
                    }}
                  </div>
                </div>
                <div class="d-flex justify-space-between grey--text text--darken-2">
                  <div>-{{ $t('Netto') }}</div>
                  <div>
                    {{
                      taxInfos[4].taxGroupTotal / (1 + taxInfos[4].taxRateGroupValue) + taxInfos[5].taxGroupTotal / (1 +
                        taxInfos[5].taxRateGroupValue) |priceDisplay
                    }}
                  </div>
                </div>
                <v-divider class="mx-2 my-2"/>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('Nettoumsatz') }}:</div>

                  <div>{{ totalInfos[0] }} €</div>
                </div>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('Umsatzsteuer') }}:</div>
                  <div>{{ totalInfos[1] }} €</div>
                </div>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('Tagsumsatz') }}:</div>
                  <div>{{ totalInfos[2] }} €</div>
                </div>
                <template v-for="(servantItem, idx) in servantInfo">
                  <div
                    :key="idx"
                    class="d-flex justify-space-between grey--text text--darken-2"
                  >
                    <div>Kellner:{{ servantItem.name }}</div>

                    <div>{{ servantItem.fTotal }} €</div>
                  </div>
                </template>
                <template v-for="(paidItem, index) in paidInfo">
                  <div
                    :key="index+ paidItem.paidName "
                    class="d-flex justify-space-between grey--text text--darken-2"
                  >
                    <div>{{ paidItem.paidName }}({{ paidItem.paidCount }})</div>

                    <div>{{ paidItem.fPaidTotal }} €</div>
                  </div>
                </template>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('Stornogesamt') }}:</div>

                  <div>{{ totalInfos[3] }} €</div>
                </div>
                <div class="d-flex justify-space-between font-weight-black grey--text text--darken-2">
                  <div>{{ $t('Rabattgesamt') }}:</div>
                  <div>{{ totalInfos[4] }} €</div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import {
    getDailyZbon,
    getRestaurantInfo,
    printZBon,
    printZbonBySpan,
    reprintZbon,
    sendZBonThroughEmail,
  } from '@/common/Utlis/api'
  import { formatDate } from '@/common/common'
  import IKUtils from 'innerken-js-utils'
  import Utils from '../../../common/Utlis/Utils'

  import Zbon from '@/model/export/Zbon'
  import GlobalConfig from '@/GlobalSettings'
  import dayjs from 'dayjs'
  import { today } from 'metaflow-js/EntityFrameWork/DateRepository'

  export default {
    props: {
      id: {
        default: -1,
        type: Number,
      },
    },
    data: function () {
      return {
        Zbon: Zbon,

        printByDay: 1, // printByDay 1 or 0
        finishZbonTime: '',
        dates: [],
        printDates: [],
        taxInfos: [],
        taxItem: {
          consumeTypeName: '',
          taxGroupTotal: 0,
          taxRateGroupValue: 0.00,
        },
        totalInfos: [],
        servantInfo: [],
        paidInfo: [],
        isAllPrint: false,
        menu: false,
        loading: false,
        currentIndex: 0,
        servantId: this.id,
        servantData: {},
        infoList: [],
        search: '',
        editedItem: {},
        pdf: null,
        nowTime: '',
        hide: false,
      }
    },
    computed: {
      todayDate: function () {
        if (Date.parse(new Date()) > Date.parse(this.finishZbonTime)) {
          return dayjs().add(-1, 'days').format('YYYY-MM-DD')
        } else {
          return dayjs().add(-2, 'days').format('YYYY-MM-DD')
        }
      },
    },
    watch: {
      dates: {
        immediate: true,
        handler: function () {
          this.reviewZbon()
        },
      },
    },
    async mounted () {
      this.finishZbonTime = today + ' 04:00:00'
      if (Date.parse(new Date()) > Date.parse(this.finishZbonTime)) {
        this.dates = [formatDate(-1), formatDate(-1)]
      } else {
        this.dates = [formatDate(-2), formatDate(-2)]
      }
    },
    methods: {
      print () {
        Utils.showConfirm('Bist du sicher?', 'Möchten Sie alle Datensätze drucken?', () => {
          printZBon().then(() => {
            Utils.toast('Erfolgreich drucken!')

            this.$refs.zbon.reload()
          })
        })
      },
      async generateZBonPDF (item) {
        window.open(GlobalConfig.getEndPoint() + 'ZBon.php?op=exportPDF&id=' + item.id)
        // await hillo.get('', { id: item.id })
      },
      async outputPdf () {
        const selectedItemIds = this.$refs.zbon.$data.selectedItems.reduce((arr, i) => {
          arr.push(i.id)
          return arr
        }, []).join(',')
        console.log(selectedItemIds)
        this.Zbon.outputMultiplePDF(selectedItemIds)
      },

      printSingleItem (item) {
        Utils.showConfirm('Bist du sicher?', 'Möchten Sie dieser Rekord drucken?', () => {
          reprintZbon(item.id).then(() => {
            Utils.toast('Erfolgreich drucken!')
            this.$refs.zbon.reload()
          })
        })
      },

      clear () {
        this.dates = []
      },
      goBack () {
        this.$router.history.go(-1)
        // this.$router.push({ name: '桌子' })
      },
      printZbonBySpan () {
        console.log(this.printDates, 'this.printDates')
        if (this.printDates.length === 2) {
          Utils.showConfirm('Bist du sicher?', 'Möchten Sie Zbon drucken?', () => {
            printZbonBySpan(this.printDates, this.isAllPrint ? '0' : '1').then(() => {
              Utils.toast('Erfolgreich drucken!')
            })
          })
        }
      },

      async reviewZbon () {
        if (this.dates.length > 0) {
          if (this.dates.length === 1) {
            this.printDates = [this.dates[0], this.dates[0]]
          } else {
            if (Date.parse(this.dates[0]) > Date.parse(this.dates[1])) {
              [this.dates[0], this.dates[1]] = [this.dates[1], this.dates[0]]
            }
            this.printDates = [this.dates[0], this.dates[1]]
          }
          this.taxInfos = []
          this.totalInfos = []
          await getDailyZbon(this.printDates).then(res => {
            res.content.content.taxInfos.forEach(item => {
              this.taxItem = IKUtils.deepCopy(item)
              this.taxInfos.push(this.taxItem)
            })
            console.log('res.content', res.content)
            this.servantInfo = res.content.content.servantInfo
            this.paidInfo = res.content.content.paidInfo
            this.totalInfos.push(res.content.content.fTotalTe)
            this.totalInfos.push(res.content.content.fTotalTax)
            this.totalInfos.push(res.content.content.fTotal)
            this.totalInfos.push(res.content.fValue)
            this.totalInfos.push(res.content.fValue2)
          })
        }
      },
      async sendZBonToEmail () {
        const res = await getRestaurantInfo()
        const emailAddress = res.content[0].ZBonEmail

        if (!emailAddress) {
          Utils.showError('Die Email Address ist leer, bitte in Restaurant Info Page einstellen')
          return false
        }
        Utils.showConfirm('Bist du sicher?', 'Möchten Sie Zbon nach Email \n' + emailAddress + '\n senden?', () => {
          const data = {
            startDate: this.printDates[0],
            endDate: this.printDates[1],
            printByDay: this.isAllPrint ? 0 : 1, // 1 print by day,  0 not
          }
          sendZBonThroughEmail(data).then(() => {
            Utils.toast('Erfolgreich gesendet!')
          })
        })
      },

      hideTime () {
        this.hide = true
      },
    },
  }
</script>

<style scoped>
.cardItem {
  margin-top: 0px;
  display: flex;
  align-content: center;
}
</style>
